{
  "common" : {
    "px" : "px",
    "px_uppercase" : "PX",
    "seconds" : "secondi",
    "other" : "-- Altro --",
    "customFieldExistsError" : "Personalizzato Campo con questo nome esiste già",
    "uniqueKeyNotUniqueError" : "Questa Chiave non è l'unica",
    "save" : "Salva",
    "saving" : "Salvataggio",
    "typeAnOption" : "Digita un'opzione",
    "unsaved" : "Non salvato",
    "noSubmissionsFound" : "Nessun invio trovato",
    "sortBy" : "Ordina per",
    "clearAll" : "Rimuovi tutto",
    "submitSurvey" : "Invia sondaggio",
    "select" : "Seleziona",
    "data" : "dati",
    "disqualifyAfterSubmitLower" : "Squalifica dopo l'invio",
    "errorRetryAgain" : "Errore, riprova di nuovo",
    "bubbleRadioStyleImageAlt" : "Stile radio bubble",
    "standardRadioStyleImageAlt" : "Stile radio standard",
    "recurringFrequency" : {
      "once" : "Una volta",
      "daily" : "Quotidiano",
      "weekly" : "Settimanale",
      "monthly" : "Mensile",
      "yearly" : "Annuale"
    },
    "yes" : "Sì",
    "no" : "No",
    "updated" : "Aggiornato",
    "new" : "Nuovo",
    "title" : "Titolo",
    "openSettings" : "Apri le impostazioni",
    "cloneField" : "Clona campo",
    "removeField" : "Rimuovi campo",
    "description" : "Descrizione",
    "cannotAddThisField" : "Non può aggiungere questo campo",
    "overallOnly" : "Solo complessivo",
    "nextSlideDefault" : "Diapositiva successiva (Predefinita)",
    "nextQuestion" : "Domanda successiva",
    "searchAddress" : "Cerca indirizzo",
    "recurringDonation" : "Donazione Ricorrente",
    "recurringDonationDay" : "Donazione ricorrente 1 giorno",
    "recurringDonationWeek" : "Donazione ricorrente settimanale 1",
    "recurringDonationMonth" : "Donazione ricorrente 1 mese",
    "recurringDonationYear" : "Donazione ricorrente di 1 anno",
    "integrate" : "Integra",
    "preview" : "Anteprima",
    "back" : "Indietro",
    "alert" : "Avviso",
    "proceed" : "Procedi",
    "confirm" : "Conferma",
    "cancel" : "Annulla",
    "delete" : "Elimina",
    "embed" : "Incorpora",
    "link" : "Link",
    "linkModal" : {
      "title" : "Inserisci link",
      "urlLabel" : "URL",
      "urlPlaceholder" : "https://www.esempio.com",
      "invalidUrl" : "L'URL non è valido"
    },
    "iframeEmbed" : "Incorporamento Iframe",
    "styles" : "Stili",
    "options" : "Opzioni",
    "quickAdd" : "Aggiunta rapida",
    "customFields" : "Campi personalizzati",
    "addObjectFields" : "Aggiungi campi oggetto",
    "personalInfo" : "Informazioni personali",
    "contactInfo" : "Informazioni di contatto",
    "submit" : "Invia",
    "address" : "Indirizzo",
    "customized" : "Personalizzato",
    "layout" : "Layout",
    "showLabel" : "Mostra etichetta",
    "showImage" : "Mostra immagine",
    "imageLayout" : "Allineamento dei contenuti dell'immagine",
    "imageLayoutSettings" : "Impostazioni layout immagine",
    "imageLayoutMode" : "Modalità di allineamento dei contenuti immagine",
    "surveyDefault" : "Impostazione predefinita del sondaggio",
    "independent" : "Indipendente",
    "image" : "Immagine",
    "desktop" : "Desktop",
    "mobile" : "Mobile",
    "desktopImage" : "Immagine Desktop",
    "mobileImage" : "Immagine Mobile",
    "uploaded" : "Caricato",
    "changeImage" : "Cambia immagine",
    "uploadImage" : "Carica immagine",
    "remove" : "Rimuovi",
    "background" : "Sfondo",
    "buttonBackground" : "Sfondo Pulsante",
    "fontColour" : "Colore Carattere",
    "textFontColour" : "Colore del carattere del testo",
    "subTextFontColour" : "Colore del carattere del testo secondario",
    "selectThemes" : "Seleziona Tema",
    "selectOne" : "Seleziona uno",
    "enableIcon" : "Abilita icona",
    "iconType" : "Tipo di icona",
    "iconPlacement" : "Posizionamento delle Icone",
    "filled" : "Compilato",
    "textOnly" : "Solo corpo",
    "border" : "Bordo",
    "borderType" : "Tipo di bordo",
    "px" : "px",
    "cornerRadius" : "Raggio d'angolo",
    "width" : "Larghezza",
    "padding" : "Spaziatura interna",
    "top" : "Superiore",
    "bottom" : "Inferiore",
    "left" : "Sinistra",
    "right" : "Destra",
    "center" : "Centro",
    "default" : "Predefinito",
    "formDefault" : "Predefinito modulo",
    "shadow" : "Ombra",
    "color" : "Colore",
    "horizontal" : "Orizzontale",
    "vertical" : "Verticale",
    "blur" : "Sfocatura",
    "spread" : "Diffondi",
    "fieldStyle" : "Stile del campo",
    "fontColor" : "Colore del carattere",
    "inputTextFillColor" : "Colore di riempimento del testo di input",
    "inputTextColor" : "Colore del testo di input",
    "primaryColor" : "Colore primario",
    "primaryColorTooltip" : "Controlla il Colore per lo stato al passaggio del mouse e lo stato Dinamico.",
    "inputTextColorTooltip" : "Controlla il Colore del Testo digitato nei campi di feedback.",
    "mapPrimaryColorToButtonColor" : "Mappa il colore primario al colore del pulsante",
    "label" : "Etichetta",
    "fontFamily" : "Famiglia di caratteri",
    "size" : "Dimensione",
    "weight" : "Peso",
    "fontWeightTooltip" : "Applicabile nel caso di paragrafi",
    "fontWeightOptions" : {
      "thin" : "100 - Sottile",
      "extraLight" : "200 - Extra Light",
      "light" : "300 - Leggero",
      "normal" : "400 - Normale",
      "medium" : "500 - Medio",
      "semiBold" : "600 - Semigrassetto",
      "bold" : "700 - Grassetto"
    },
    "placeholder" : "Segnaposto",
    "customCSS" : "CSS personalizzato",
    "backgroundImage" : "Immagine di sfondo",
    "headerImage" : "Immagine dell'intestazione",
    "miscellaneous" : "Varie",
    "agencyBranding" : "Branding dell'agenzia",
    "imageUploadMessage" : "Fai clic su un file immagine o trascinalo in quest'area per caricarlo",
    "backgroundImageTooltipMessage" : "L'immagine di sfondo deve coprire l'intera pagina, fornendo uno sfondo visivamente accattivante per il modulo. Per visualizzare l'immagine di sfondo, fai clic sull'opzione Anteprima.",
    "headerImageTooltipMessage" : "L'immagine dell'intestazione è progettata per coprire l'intera larghezza del modulo e rimane posizionata nella parte superiore del modulo. Per visualizzare l'immagine dell'intestazione, fai clic sull'opzione Anteprima.",
    "onSubmit" : "All'invio",
    "facebookPixelID" : "ID pixel di Facebook",
    "facebookPixelIDMessage" : "Ignora questo campo se prevedi di utilizzare questo modulo/sondaggio all'interno di un funnel",
    "facebookPixelEvents" : "Eventi del pixel di Facebook",
    "onpageView" : "Visualizzazione sulla pagina",
    "stickyContact" : "Contatto frequente",
    "stickyContactMessage" : "Memorizza e compila automaticamente i dettagli di contatto quando l'utente ritorna sullo stesso dispositivo e browser.",
    "fieldDescription" : "Descrizione del campo",
    "fieldTitle" : "Titolo del campo",
    "queryKey" : "Chiave della query",
    "querykeyTooltipMessage" : "La chiave della query che può essere usata come parametro dell'URL per popolare questo campo",
    "required" : "Obbligatorio",
    "hidden" : "Nascosto",
    "hiddenValue" : "Valore nascosto",
    "enableCountryPicker" : "Abilita selettore di paese",
    "altText" : "Testo alternativo",
    "optionImageAlt" : "Option image",
    "bannerAlt" : "banner",
    "avatarAlt" : "Avatar Name",
    "alignment" : "Allineamento",
    "imageWidth" : "Larghezza dell'immagine",
    "imageHeight" : "Altezza dell'immagine",
    "logic" : "Logica",
    "pleaseInput" : "Inserisci",
    "editHTML" : "Modifica HTML",
    "textStyle" : "Stile del testo",
    "subText" : "Testo secondario",
    "text" : "Testo",
    "buttonStyle" : "Stile del pulsante",
    "fullWidth" : "Larghezza completa",
    "htmlMessage" : "L'HTML personalizzato va qui",
    "htmlEditorHeader" : "JAVASCRIPT / HTML PERSONALIZZATO",
    "htmlEditorBodyMessage" : "Aggiungi qui il tuo codice",
    "scriptAdded" : "Script Added!",
    "sourceAdded" : "Source Added!",
    "yesSave" : "Sì, salva",
    "cancelKeep" : "Annulla, mantieni",
    "done" : "Fatto",
    "addElement" : "Aggiungi elemento",
    "addUrlLike" : "Inserisci URL validi, come ad esempio",
    "doNotAddRelativePath" : "Non aggiungere percorsi relativi come",
    "or" : "o",
    "addCustomFields" : "Aggiungi campi personalizzati",
    "customFieldSearch" : "Cerca per nome",
    "enterSourceValue" : "Inserisci il valore della fonte",
    "shortLabel" : "Etichetta breve",
    "shortLabelPlaceholder" : "Carattere a Etichetta breve",
    "labelPlaceholder" : "Digita un'etichetta",
    "fileUploadPlaceholder" : "Carica un File",
    "imagePlaceholder" : "Image",
    "fillValuesPlaceholder" : "Riempi i valori",
    "customCSSTooltip" : "Il CSS personalizzato ha la precedenza sullo stile dei moduli e sui temi e può avere un impatto sullo stile del tema.",
    "fontFamilyTooltip" : "Builder supporta tutti i tipi di font, se non lo vedi nell'elenco. Cercalo nel menu a discesa",
    "useGDPRCompliantFont" : "Usa carattere conforme al GDPR",
    "enableTimezone" : "Abilita fuso orario",
    "inputStyle" : "Stile di inserimento",
    "conditionalLogicAlertOnSubmit" : "La logica condizionale avrà la precedenza sul messaggio/reindirizzamento",
    "conditionalLogicAlertOnShowHide" : "La logica condizionale avrà la precedenza sulle impostazioni nascoste",
    "placeholderFacebookPixelIdInput" : "Inserisci l'ID pixel di Facebook",
    "doNotShowMessage" : "Non mostrare più",
    "creatingForm" : "Crea il tuo modulo...",
    "creatingSurvey" : "Crea il tuo Sondaggio...",
    "creatingQuiz" : "Crea il tuo quiz...",
    "errorCreatingForm" : "Lì è stato un errore Crea il tuo Modulo. Riprova.",
    "errorCreatingSurvey" : "Lì è stato un errore Crea il tuo Sondaggio. Riprova.",
    "errorCreatingQuiz" : "Lì è stato un errore Crea il tuo quiz. Riprova.",
    "redirectMessage" : "Ti reindirizzeremo a:",
    "themes" : {
      "themes" : "Temi",
      "alertThemeMessage" : "Il cambio di tema comporterà la perdita di tutte le modifiche di stile attuali.",
      "useTheme" : "Utilizza il tema",
      "removeTheme" : "Rimuovi il tema"
    },
    "box" : "Casella",
    "line" : "Linea",
    "message" : "Messaggio",
    "openUrl" : "Reindirizza all'URL",
    "borderTypeList" : {
      "dotted" : "Punteggiato",
      "dashed" : "Tratteggiato",
      "solid" : "Uniforme",
      "none" : "Nessuno"
    },
    "button" : "Pulsante",
    "emailNotification" : "Notifica email",
    "emailNotificationSubheader" : "Ricevi un'e-mail quando qualcuno compila il tuo modulo",
    "subject" : "Oggetto",
    "emailTo" : "Email (a)",
    "senderName" : "Nome del mittente",
    "senderNameWarning" : "Il tuo (nome del sottoaccount) verrà aggiunto se lasciato vuoto",
    "emailError" : "È richiesto almeno un indirizzo email",
    "emailTooltip" : "Il primo indirizzo email è designato per il campo \"A\". Tutti gli indirizzi email successivi verranno inclusi nel campo \"Cc\".",
    "clear" : "Rimuovi",
    "filter" : "Filtra",
    "noResults" : "Nessun risultato",
    "search" : "Cerca",
    "showNotificationsSettings" : "Mostra impostazioni delle notifiche",
    "emailServicePaid" : "Questa funzionalità è un servizio a pagamento e comporterà costi in base all'utilizzo.",
    "integration" : "Integrazione",
    "validation" : {
      "fieldRequired" : "Campo è Obbligatorio",
      "maxLengthExceeded" : "Massimo Lunghezza ha superato ({max} Carattere)"
    },
    "securityValidation" : {
      "title" : "Problemi di sicurezza individuati. Non sono consentiti i seguenti elementi:",
      "cookieAccess" : "Rilevato accesso ai cookie (document.cookie). Per motivi di sicurezza, questo non è consentito.",
      "storageAccess" : "localStorage.getItem() - la lettura da localStorage non è permessa.",
      "evalUsage" : "L'uso di eval() non è consentito in quanto può eseguire codice arbitrario.",
      "dynamicFunction" : "La creazione dinamica di funzioni (new Function) non è consentita per motivi di sicurezza.",
      "stringExecution" : "Il passaggio di stringhe a setTimeout/setInterval non è consentito poiché può eseguire codice arbitrario. Usa invece riferimenti di funzione."
    },
    "products" : {
      "subscriptionBadge" : "Abbonamento",
      "trialBadge" : "Prova gratuita di {days} giorno",
      "setupFee" : "Costo di configurazione una tantum",
      "quantity" : "Quantità",
      "productImageAlt" : "Immagine prodotto",
      "bumpIconAlt" : "Icona opzione aggiuntiva"
    },
    "payment" : {
      "payments" : "Pagamenti",
      "connected" : "Collegato",
      "connect" : "Collega",
      "liveModeOn" : "Modalità live",
      "status" : "Stato",
      "test" : "Test",
      "live" : "Live",
      "paymentFields" : "Campi di pagamento",
      "suggestAnAmount" : "Suggerisci un importo",
      "recurringPayments" : "Pagamenti Ricorrenti",
      "selectCurrency" : "Seleziona la valuta",
      "tagActiveBGColor" : "Colore etichetta attiva",
      "includeOtherAmount" : "Includi altro importo",
      "footerInfo" : "Info piè di pagina",
      "paymentType" : "Tipo di pagamento",
      "sellProducts" : "Vendi prodotti",
      "customAmount" : "Importo personalizzato",
      "collectPayment" : "Raccogli pagamento",
      "generalSettings" : "Campi generali",
      "securePayments" : "*Blocca al 100% e pagamenti sicuri*",
      "error" : {
        "addMainProductFirst" : "Aggiungi prima un PRIMARIO Prodotto",
        "priceNotFoundForBumpProduct" : "Prezzo non trovato per il Prodotto aggiuntivo",
        "productAlreadyAdded" : "Prodotto già aggiunto"
      },
      "product" : {
        "addProduct" : "Aggiungi prodotto",
        "productSettings" : "Impostazioni prodotto",
        "bumpTag" : "Opzione aggiuntiva",
        "settingsAria" : "Impostazioni prodotto",
        "deleteAria" : "Elimina prodotto",
        "selectProduct" : "Seleziona prodotto",
        "editThisProduct" : "Per modificare questo prodotto",
        "clickHere" : "Fai clic qui",
        "show" : "Mostra",
        "description" : "Descrizione",
        "image" : "Immagine",
        "layoutSettings" : "Impostazioni di layout",
        "singleColumn" : "Colonna singola",
        "twoColumn" : "Due colonne",
        "threeColumn" : "Tre colonne",
        "maxProductError" : "In un modulo sono consentiti al massimo 20 prodotti",
        "productSelectPlaceholder" : "Seleziona un prodotto",
        "orderConfirmation" : "Conferma dell'ordine",
        "orderConfirmationWarning" : "Una volta che il pagamento è andato a buon fine, verrà visualizzata una pagina di conferma dell'ordine",
        "quantity" : "Quantità",
        "createProduct" : "Per creare un prodotto",
        "noProductsAdded" : "Nessun prodotto ancora aggiunto",
        "productsWillShowHere" : "Una volta che i prodotti Tu Includi, mostreranno Destra qui",
        "chooseProductType" : "Seleziona prodotto digitale",
        "mainProduct" : "PRIMARIO Prodotto"
      },
      "bumProduct" : {
        "price" : "Prezzo",
        "variant" : "Variante",
        "headline" : "Titolo",
        "otoHeadline" : "Titolo OTO",
        "otoText" : "OTO Corpo",
        "enableImage" : "Abilita Immagine",
        "imageMessage" : "Afferriamo il Predefinito Prodotto Immagine",
        "orUploadADifferentImage" : "O Carica a different Immagine",
        "bumpProducts" : "Prodotti aggiuntivi",
        "bumpProduct" : "Prodotto aggiuntivo",
        "enableBump" : "Abilita urto",
        "orderBumpStyle" : "Offerta aggiuntiva Stile aggiuntivo",
        "classic" : "Classico",
        "modern" : "Moderno",
        "icon" : "Icona",
        "bumpTemplate" : "Seleziona Modello",
        "highlightText" : "Evidenzia Corpo",
        "showPrice" : "Mostra Prezzo",
        "bumpPriceColor" : "Prezzo aggiuntivo",
        "bumpIconColor" : "Icona di urto",
        "bumpBackgroundColor" : "Sfondo a Sfondo",
        "highlightTextColor" : "Evidenzia Corpo",
        "headlineColor" : "Titolo",
        "otoHeadlineColor" : "Titolo OTO",
        "otoTextColor" : "OTO Corpo",
        "bumpBorderColor" : "Bordo a Bordo",
        "priceRequired" : "Il prezzo è obbligatorio",
        "headlineRequired" : "Il titolo è Obbligatorio",
        "otoHeadlineRequired" : "Il titolo dell'offerta una tantum è obbligatorio",
        "otoTextRequired" : "Il testo dell'offerta una tantum è obbligatorio",
        "bumpProductTooltip" : "Un Piccolo Componente aggiuntivo offerto durante Pagamento a Moltiplica Ordina Valore. I Clienti possono includerlo con un Individuo fai clic.",
        "templateOne" : "Modello 1",
        "templateTwo" : "Modello 2",
        "templateThree" : "Modello 3",
        "animationIcon" : {
          "none" : "Nessuno",
          "arrow" : "Freccia",
          "fire" : "Fuoco",
          "plus" : "Più",
          "giftBox" : "Casella regalo",
          "timer" : "Conto alla rovescia",
          "cracker" : "Cracker",
          "snack" : "Spuntino",
          "partyBalloon" : "Palloncino per feste",
          "flash" : "Flash",
          "money" : "Valuta",
          "spaceShuttle" : "Navetta Spazio"
        }
      },
      "coupons" : {
        "coupons" : "Coupon",
        "enableCoupon" : "Abilita coupon",
        "couponAlignment" : "Allineamento del coupon",
        "left" : "Sinistra",
        "right" : "Destra",
        "fullWidth" : "Larghezza completa",
        "tooltipMessage" : "Imposta la posizione di inserimento del coupon dai tipi sottostanti"
      }
    },
    "addressSettings" : {
      "autoComplete" : "Indirizzo a completamento automatico",
      "addressfields" : "Campi indirizzo",
      "placeholderSearch" : "Cerca un indirizzo",
      "autoCompleteTooltip" : "Fornisce la possibilità di cercare e popolare automaticamente l'indirizzo.",
      "streetAddress" : "Indirizzo",
      "autoCompleteAddressTitle" : "Automatico Termina Indirizzo",
      "newBadge" : "Nuovo",
      "defaultLabel" : "Indirizzo",
      "searchPlaceholder" : "Cerca Indirizzo",
      "mandataorySearch" : {
        "title" : "Obbligatorio a selezionare Indirizzo in Cerca Bar",
        "primaryText" : "Completamento automatico solo per Indirizzo",
        "secondaryText" : "Quando Abilitato, quando un utente interagisce con l'Indirizzo Campo, Poi deve selezionare un Indirizzo valido per Procedi.",
        "secondaryText1" : "Quando Disabilitato Poi possono Procedi senza selezionare un Indirizzo in barra Cerca."
      }
    },
    "autoResponder" : "Risponditore automatico",
    "autoResponderSubheader" : "Invia un'email automatica alla persona che invia il modulo (l'email include una copia delle informazioni inserite nel modulo)",
    "replyToEmail" : "Rispondi all'email",
    "open" : "Aperta",
    "won" : "Vinta",
    "lost" : "Persa",
    "abandon" : "Abbandona",
    "selectAPipeline" : "Seleziona una sequenza",
    "stage" : "Fase",
    "status" : "Stato",
    "opportunityValue" : "Valore dell'opportunità",
    "createNewPipeline" : "Crea una nuova sequenza",
    "editOpportunitySettings" : "Modifica le impostazioni delle opportunità",
    "contact" : "Contatto",
    "opportunity" : "Opportunità",
    "business" : "Impresa",
    "add" : "Aggiungi",
    "manage" : "Gestisci",
    "more" : "Più",
    "opportunityHeading" : "Dove vuoi che la tua opportunità venga aggiornata?",
    "date" : {
      "dateSettings" : "Impostazioni data",
      "dateFormat" : "Formato data",
      "dateSeparator" : "Separatore di data",
      "dateFormatTooltipMessage" : "Seleziona un formato di data. D sta per giorno, M per mese e Y per anno",
      "dateSeparatorTooltipMessage" : "Seleziona un separatore che separerà giorno, mese e anno nel formato selezionato in Formato data",
      "disablePicker" : "Disabilita selettore"
    },
    "restoreVersion" : "Ripristina versione",
    "versionHistory" : "Cronologia delle versioni",
    "errorMessage" : "Errore, riprova di nuovo",
    "version" : "Versione:",
    "currentVersion" : "Versione attuale",
    "messageStyling" : "Stile dei messaggi",
    "validateEmailHeader" : "Convalida email",
    "validateEmailDescription" : "Il pulsante diventerà visibile una volta che l'utente avrà inserito la propria email. Questa funzione è progettata per aiutarti a generare lead di qualità.",
    "verifyEmail" : "Verifica email",
    "validatePhoneHeader" : "Convalida telefono",
    "validatePhoneDescription" : "Il pulsante diventerà visibile una volta che l'utente avrà inserito il proprio numero di telefono. Questa funzione è progettata per aiutarti a generare lead di qualità.",
    "verifyPhone" : "Verifica telefono",
    "validatePhoneWarning" : "Per abilitare la verifica OTP via SMS, assicurati che il tuo numero di telefono sia configurato nelle tue impostazioni di luogo",
    "addAnotherTnc" : "Aggiungi altri termini e condizioni",
    "tnc1" : "Termini e condizioni 1",
    "tnc2" : "Termini e condizioni 2",
    "deleteCaps" : "DELETE",
    "deleteConfirmation" : "Digita DELETE per confermare",
    "marginPadding" : "Margine e spaziatura interna",
    "style" : {
      "formLayoutType" : "Tipo di modulo",
      "layoutType" : "Tipo di Layout",
      "surveyType" : "Tipo di Sondaggio",
      "oneColumn" : "Una colonna",
      "twoColumn" : "Due colonne",
      "singleLine" : "Linea singola",
      "fieldWidth" : "Larghezza del campo",
      "labelAlignment" : {
        "labelAlignment" : "Allineamento etichetta",
        "labelWidth" : "Larghezza etichetta"
      },
      "fieldSpacing" : "Spaziatura dei campi",
      "imageFieldSpacing" : "Spaziatura di campi e immagini",
      "imageCornerRadius" : "Raggio d'angolo dell'immagine",
      "color" : "colore",
      "fontColor" : "Colore del carattere",
      "inputBackgroundColor" : "Colore di sfondo di input",
      "inputBorder" : "Bordo di input",
      "layout" : "Layout",
      "colorsAndBackground" : "Colori e sfondo",
      "imageLayout" : {
        "imageLayout" : "Immagine Allineamento dei contenuti",
        "showImage" : "Mostra immagine",
        "image" : "Immagine",
        "desktop" : {
          "topFixed" : "Migliore Fisso",
          "leftCenter" : "Centro sinistra",
          "rightCenter" : "Centro a destra",
          "leftFixed" : "Fisso a Sinistra",
          "rightFixed" : "Fisso a destra",
          "background" : "Sfondo"
        },
        "mobile" : {
          "header" : "Intestazione",
          "background" : "Sfondo"
        }
      },
      "focusPoint" : {
        "title" : "Punto focale",
        "reset" : "Reimposta",
        "noImage" : "Nessuna immagine caricata"
      },
      "advanceSettings" : "Impostazioni avanzate",
      "inputField" : "Campo di inserimento",
      "borderWidth" : "Larghezza del bordo",
      "borderColor" : "Colore del bordo",
      "borderStyle" : "Stile del bordo",
      "fontSize" : "Dimensione del carattere",
      "fontWeight" : "Peso del carattere",
      "labelColor" : "Colore etichetta",
      "placeholderColor" : "Colore segnaposto",
      "shortLabelColor" : "Colore dell'etichetta breve"
    },
    "replyToTooltip" : "Personalizza l'indirizzo email di risposta predefinito utilizzando {'{'}{'{'}contact.email{'}'}{'}'} per abilitare le risposte al contatto che invia il modulo.",
    "content" : "Contenuti",
    "calculations" : "Calcoli",
    "uploadOptions" : "Opzioni di caricamento",
    "opportunitySettingsWarning" : "Per configurare le impostazioni dell'opportunità, fai clic sul pulsante Modifica impostazioni opportunità.",
    "startValue" : "Valore di Inizio",
    "endValue" : "Valore finale",
    "today" : "Oggi",
    "thisWeek" : "Questa settimana",
    "last7Days" : "Ultimi 7 giorni",
    "thisMonth" : "Questo mese",
    "last30Days" : "Ultimi 30 giorni",
    "question" : "Domanda",
    "createContactOnPartialSubmission" : "Crea contatto con invio parziale",
    "howItWorks" : "Come funziona?",
    "createContactOnPartialSubmissionDescription" : "Termina la diapositiva e fai clic su \"Successivo\". Un nuovo contatto verrà creato e memorizzato automaticamente.",
    "swapWarningMessageSurvey" : "La modifica o lo scambio delle opzioni influirà su questo campo personalizzato in tutti i luoghi in cui viene utilizzato il campo. Può anche resettare la logica condizionale. ",
    "swapWarningMessageForm" : "La modifica o lo scambio delle opzioni influirà su questo campo personalizzato in tutti i luoghi in cui viene utilizzato il campo. ",
    "migrationWarningMessage" : "Questa funzionalità è stata migrata alla logica condizionale del sondaggio.",
    "optionLabel" : "Etichetta opzione",
    "calculationValue" : "Valore di calcolo",
    "addOption" : "Aggiungi opzione",
    "enableCalculations" : "Abilita calcoli",
    "allowOtherOption" : "Consenti Altra Opzione",
    "productSelectionSubtext" : "Abilitazione individuale o selezione di Prodotti multipli",
    "multi" : "Multi",
    "single" : "Individuo",
    "productSelectionHeading" : "Selezione Prodotto",
    "spreadToColumns" : "Diffondi in colonne",
    "columns" : "Colonne",
    "customstyle" : "Stile",
    "standard" : "Standard",
    "bubble" : "Bubble",
    "integratePopup" : {
      "title" : "Integra modulo",
      "embedCode" : "Codice di incorporamento",
      "useInFunnelOrEmbedCode" : "Usa in funnel/codice di incorporamento",
      "iframeEmbed" : "Incorpora Iframe",
      "layout" : {
        "title" : "Tipo di layout incorporato",
        "description" : "Seleziona un layout da incorporare in un funnel o in un sito web esterno",
        "allowMinimize" : "Consenti riduzione a icona",
        "minimizedTitlePlaceholder" : "Titolo ridotto",
        "leftAlignAlt" : "Allinea a sinistra",
        "rightAlignAlt" : "Allinea a destra"
      },
      "triggerType" : "Tipo di trigger",
      "triggers" : {
        "seconds" : "secondi"
      },
      "activation" : {
        "title" : "Opzioni di attivazione",
        "visit" : "visita"
      },
      "deactivation" : {
        "title" : "Opzioni di disattivazione",
        "times" : "volte"
      },
      "copyEmbedCode" : "Copia codice di incorporamento",
      "copyFormLink" : "Copia link del modulo",
      "openFormLink" : "Apri il link del modulo",
      "invalidInput" : "Input non valido!",
      "funnel" : {
        "funnel" : "Funnel",
        "chooseStep" : "Seleziona a Passaggio",
        "copyCodeAndOpenFunnel" : "Copia Codice e Apri Funnel"
      },
      "share" : {
        "share" : "Condividi",
        "shareViaSocials" : "Condividi tramite Social",
        "copyLink" : "Copia link"
      },
      "email" : {
        "email" : "Email",
        "shareViaEmail" : "Condividi tramite Email",
        "emailButton" : "Email",
        "blankTemplate" : "Modello vuoto",
        "emailMarketingTemplates" : "Modelli Email Marketing",
        "or" : "O",
        "chooseTemplate" : "Scegli dai tuoi modelli",
        "continue" : "Continua"
      }
    },
    "rating" : {
      "icon" : "Icona",
      "iconAlignment" : "Allineamento Icona",
      "count" : "Numero",
      "lowestRating" : "Valutazione minima",
      "highestRating" : "Valutazione Massimo",
      "iconSelectedState" : "Stato Icona Selezionato",
      "iconUnselectedState" : "Stato Icona non selezionato",
      "rating" : "Valutazione",
      "ratingSettings" : "Impostazioni Valutazione",
      "calculationType" : {
        "calculationType" : "Come Archivia Valutazione Campi in Personalizzato Campi",
        "calculationTypeTooltip" : "Quando Tu Frequenza qualcosa di 4 Da 5 stelle, significa: - Assoluto: 4 Da 5 - Percentuale: 80 - Frazione: 0.8",
        "absolute" : "Assoluto",
        "percentage" : "Percentuale",
        "fraction" : "Frazione"
      }
    },
    "desktopMode" : "Modalità desktop",
    "mobileMode" : "Modalità mobile",
    "versions" : "Varianti",
    "advanced" : "Avanzato",
    "edit" : "Modifica",
    "settings" : "Impostazioni",
    "submissions" : "Invii",
    "undo" : "Annulla",
    "redo" : "Ripeti",
    "customValues" : "Valori personalizzati",
    "pickBgFromImage" : "Aggiunge una sfocatura sullo sfondo della tua casella dei messaggi. Se scegli un colore di sfondo per la casella dei messaggi, appare sopra la casella sfocata.",
    "pickBgFromImageTip" : "Consente di selezionare un Colore con Confronta elevato per l'Immagine BG. Messaggio: non verrà applicata se lo Sfondo del Modulo non ha un'Immagine",
    "messageBackgroundBlur" : "Sfocatura dello sfondo",
    "confirmationMessage" : "Messaggio di conferma",
    "deleteOption" : "Elimina opzione",
    "deleteConfirmationModal" : {
      "defaultDescription" : "L'eliminazione di un'opzione influirà su questa Personalizzato Campo su ogni Posti in cui viene utilizzato Campo. Sei sicuro che tu desideri eliminarlo?",
      "validationMessage" : "Inserisci Elimina in Salva.",
      "validationError" : "Inserisci Elimina"
    },
    "disqualifyImmediately" : "Squalifica immediatamente",
    "disqualifyAfterSubmit" : "Squalifica dopo l'invio",
    "generalSettings" : "Impostazioni Generale",
    "advancedSettings" : "Impostazioni avanzate",
    "customFieldName" : "Personalizzato Settore Nome",
    "customFieldNameTooltip" : "Questo Settore Nome è unico per Personalizzato Settore.",
    "uniqueKey" : "Chiave univoca",
    "uniqueKeyTooltip" : "Questa Chiave è unica per Personalizzato Settore.",
    "selectContactAssociation" : "Seleziona la relazione con i Contatti",
    "associations" : "Associazioni",
    "createNewAssociation" : "Crea nuova associazione",
    "selectAnAssociation" : "Seleziona un'associazione",
    "loadingAssociations" : "Caricamento delle associazioni...",
    "unknownAssociation" : "Relazione Sconosciuta",
    "manyToMany" : "Molti a molti",
    "failedToLoadAssociations" : "Caricamento delle associazioni non riuscito",
    "noAssociationsFound" : "Nessuna associazione trovata",
    "keepThisField" : "Mantieni questo campo",
    "association" : "Associazione",
    "customObject" : "Oggetto personalizzato",
    "customObjects" : "Oggetti personalizzati",
    "object" : "Oggetto",
    "editAssociation" : "Modifica associazione {objectName}",
    "editAssociationButton" : "{edit} {objectName} {association}",
    "fields" : "Campi",
    "primaryFieldWarning" : "{fieldName} è un campo PRIMARIO per {objectSingular} ed è Obbligatorio per creare o aggiornare un {objectSingular}.",
    "primaryFieldTitle" : "{fieldName} è Obbligatorio per creare o Aggiornare il Documento {objectSingular}.",
    "removeAllFields" : "Rimuovi tutti i campi {objectSingular}",
    "customObjectsFallback" : "Oggetti personalizzati",
    "noneAssociation" : "Nessuno",
    "noneAssociationDescription" : "Nessuna relazione con i Contatti (nessun Campo Contatto presente)",
    "survey" : {
      "layoutType" : "Tipo di sondaggio",
      "oneQuestionPerPage" : "Una domanda alla volta",
      "allQuestionsOnePage" : "Molte alla volta"
    },
    "quizQuestions" : "Interrogatorio del quiz",
    "choiceElements" : "Scelta componenti",
    "otherElements" : "Altro Componenti",
    "listEditor" : {
      "prefillValueHeader" : "Valore Precompila",
      "labelPlaceholder" : "Etichetta",
      "valuePlaceholder" : "Valore",
      "optionRequiredError" : "L'opzione Campo è Obbligatorio"
    },
    "field" : "Campo",
    "scoreEditor" : {
      "addFieldPlaceholder" : "Aggiungi Campo",
      "fieldLabel" : "Campo",
      "numberLabel" : "numero"
    },
    "fileUploadEditor" : {
      "fileTypes" : "Tipi File",
      "all" : "ogni",
      "pdf" : "PDF",
      "docxDoc" : "DOCX/DOC",
      "png" : "PNG",
      "gif" : "GIF",
      "jpgJpeg" : "JPG/JPEG",
      "xlsCsv" : "XLS/CSV"
    },
    "ok" : "Ok",
    "allowMultipleFiles" : "Abilita File multipli",
    "maxFileLimit" : "Limite Massimo File",
    "privacyPolicy" : "Informativa sulla privacy",
    "termsOfService" : "Termini di servizio",
    "colorPicker" : {
      "brandColors" : "Colori del brand",
      "defaultColors" : "Colori predefiniti",
      "globalCustomColors" : "Colori personalizzati globali"
    },
    "billingFrequency" : "Frequenza di Fatturazione",
    "otherAmount" : "Altro importo",
    "exampleUrlPlaceholder" : "https://www.esempio.com",
    "checkboxStyles" : {
      "standardAlt" : "Stile casella di controllo standard",
      "bubbleAlt" : "Stile casella di controllo bubble"
    },
    "previewIcons" : {
      "exportAlt" : "Icona di esportazione",
      "shipmentAlt" : "Icona di spedizione",
      "resultAlt" : "Icona della pagina dei risultati"
    },
    "examples" : {
      "sampleUrl" : "https://esempio.com"
    },
    "showing" : "Presentazione",
    "of" : "di",
    "enterCouponCode" : "Inserisci codice coupon",
    "apply" : "Applica",
    "paymentWillBeProcessed" : "Il pagamento verrà elaborato non appena procederai al passaggio successivo",
    "paymentWillBeProcessedNextSlide" : "Il pagamento verrà elaborato non appena l'utente procederà alla diapositiva successiva",
    "showThisAlertToUsers" : "Mostra questo avviso agli utenti",
    "sixteenDigitCardNumber" : "Numero di carta a 16 cifre",
    "mmYy" : "MM / AA",
    "cvc" : "CVC",
    "pleaseFillRequiredFields" : "Compila tutti i campi obbligatori!",
    "opportunitySettingsIncomplete" : "Impostazioni delle opportunità incomplete",
    "opportunitySettingsIncompleteDescription" : "Questo modulo include i campi Opportunità, ma le impostazioni delle opportunità non sono state aggiornate. Configura le impostazioni delle opportunità per procedere con il salvataggio del modulo.",
    "ariaAttributes" : {
      "iconSearch" : "Ricerca icona"
    },
    "alt" : {
      "standardRadioStyle" : "Stile radio standard",
      "bubbleRadioStyle" : "Stile radio bubble"
    },
    "value" : "Valore",
    "jumpTo" : "Salta a",
    "thankYouJohnDoe" : "Grazie, signor John Doe",
    "total" : "Totale",
    "urlExamples" : {
      "simple" : "esempio.com",
      "https" : "https://esempio.com",
      "withPath" : "example.com/path",
      "fullPath" : "https://www.example.com/path"
    }
  },
  "fields" : {
    "quizQuestions" : {
      "singleChoice" : "Scelta individuale",
      "multipleChoice" : "Scelta multipla",
      "yesNo" : "Sì / No",
      "shortAnswer" : "Video breve Risposto",
      "longAnswer" : "Risposto lungo",
      "number" : "numero",
      "singleDropdown" : "Elenco a discesa individuale",
      "multiDropdown" : "Elenco a Elenco a discesa multiplo"
    },
    "personal" : {
      "fullName" : "Nome Pieno",
      "firstName" : "Nome",
      "lastName" : "Cognome",
      "dateOfBirth" : "Data di nascita",
      "phone" : "Telefono",
      "email" : "Gmail"
    },
    "submit" : {
      "button" : "Pulsante"
    },
    "integration" : {
      "sellProducts" : "Vendi prodotti",
      "collectPayment" : "Raccogli Pagamento"
    },
    "address" : {
      "address" : "Indirizzo",
      "streetAddress" : "Indirizzo",
      "city" : "Città",
      "state" : "Stato",
      "country" : "Paese",
      "postalCode" : "Codice postale",
      "organization" : "Gruppo",
      "website" : "Sito web",
      "websitePlaceholder" : "L'URL web va qui"
    },
    "text" : {
      "singleLine" : "Linea individuale",
      "multiLine" : "Linea",
      "textBoxList" : "Testo Quadrato"
    },
    "choiceElements" : {
      "singleDropdown" : "Elenco a discesa individuale",
      "multiDropdown" : "Elenco a Elenco a discesa multiplo",
      "checkbox" : "Casella di controllo",
      "radio" : "Radio button"
    },
    "customized" : {
      "text" : "Fai clic per modificare questo testo",
      "html" : "Html",
      "htmlPlaceholder" : "L'HTML Personalizzato va qui",
      "captcha" : "Captcha",
      "source" : "Fonte",
      "termsAndConditions" : "T & C",
      "termsAndConditionsPlaceholder" : "Accetto i termini e le condizioni Emesso tramite l'impresa. Tramite fornendo il mio Numero di telefono, accetto che Eredita Testo invii messaggi Da the business.",
      "score" : "Punteggio"
    },
    "other" : {
      "image" : "Immagine",
      "fileUpload" : "Carica File",
      "monetary" : "Monetario",
      "number" : "numero",
      "datePicker" : "Selettore Data",
      "signature" : "Firma"
    },
    "customstyle" : "Stile",
    "standard" : "Standard",
    "bubble" : "Bubble"
  },
  "survey" : {
    "typeOfBuilder" : "Sondaggio",
    "survyeStyle" : "Stile del sondaggio",
    "surveyName" : "Nome del sondaggio",
    "surveyElement" : "Elemento del sondaggio",
    "addSurveyElement" : "Aggiungi elemento del sondaggio",
    "cloneSlide" : "Clone Scorri",
    "unsavedAlertMessage" : "Il sondaggio contiene lavoro non salvato. Vuoi davvero uscire ed eliminare tutto il lavoro non salvato?",
    "thirdPartyScriptAlertMessage" : "Gli script di terze parti all'interno del blocco HTML possono fornire potenti funzionalità, ma comportano anche rischi per la privacy, la sicurezza, le prestazioni e il comportamento della pagina. Pertanto, ti consigliamo di rivedere il contenuto di questo script prima di salvarlo nel sondaggio.",
    "integrateHeader" : "Integra sondaggio",
    "integrateSubHeader" : "Usa le seguenti opzioni per integrare il tuo sondaggio personalizzato nel tuo sito web",
    "integrateCopyLinkMessage" : "Copia il link qui sotto e condividilo facilmente ovunque desideri.",
    "onSurveySubmission" : "All'invio del sondaggio",
    "surveySettings" : "Impostazioni sondaggio",
    "oneQuestionAtTime" : "Una domanda alla volta",
    "backButton" : "Pulsante Indietro",
    "backButtonTooltipMessage" : "Il pulsante Indietro aiuterà gli utenti a spostarsi alla diapositiva precedente",
    "disableAutoNavigation" : "Disabilita navigazione automatica",
    "disableAutoNavigationTooltipMessage" : "Passa automaticamente alla risposta di Successivo Scorri Dopo un utente.",
    "autoNavigation" : "Navigazione Automatico",
    "autoNavigationTooltipMessage" : "Passa automaticamente alla risposta di Successivo Scorri Dopo un utente.",
    "progressBar" : "Barra di avanzamento",
    "progressBarTooltipMessage" : "Disattivando questa opzione verrà rimossa la barra di avanzamento dal sondaggio",
    "disableAnimation" : "Disabilita animazione",
    "disableAnimationTooltipMessage" : "Attivando questa opzione verrà disabilitata l'animazione di transizione della diapositiva",
    "scrollToTop" : "Scorri verso l'alto",
    "scrollToTopTooltipMessage" : "Se l'opzione è attivata, il sondaggio scorrerà verso l'alto nella diapositiva successiva",
    "submitSurvey" : "Invia sondaggio",
    "disqualifyImmediately" : "Squalifica immediatamente",
    "disqualifyAfterSubmit" : "Squalifica dopo l'invio",
    "disqualifyAfterSubmitLowerCase" : "Squalifica dopo l'invio",
    "footerHTML" : "Piè di pagina HTML",
    "footerHTMLMessage" : "Puoi scrivere CSS personalizzati (usando l'etichetta di stile) e HTML all'interno della stessa casella",
    "editFooter" : "Modifica piè di pagina",
    "disqualifySettings" : "Impostazioni di squalifica",
    "disqualifyImmediatelyLabel" : "Immediatamente",
    "disqualifyAfterSubmitLabel" : "Dopo l'invio",
    "slideConflictAlertMessage" : "Questa diapositiva contiene più domande con una logica impostata. Ciò può causare alcuni comportamenti indesiderati",
    "addSlide" : "Aggiungi diapositiva",
    "settings" : "Impostazioni",
    "delete" : "Elimina",
    "slideDeleteAlertMessage" : "Vuoi davvero eliminare questa diapositiva?",
    "slideDeleteBetweenAlertMessage" : "Questo riorganizzerà le altre diapositive. Vuoi davvero eliminare questa diapositiva?",
    "slideLabel" : "Diapositiva {n}",
    "slideName" : "Nome diapositiva",
    "slidePosition" : "Posizione della diapositiva",
    "jumpTo" : "Salta a",
    "jumpToSubText" : "Vai a una diapositiva specifica",
    "enableTimezoneSurvey" : "L'attivazione di questa opzione acquisirà le informazioni sul fuso orario della persona che invia il sondaggio",
    "footer" : {
      "footer" : "Piè di pagina",
      "enableNewFooter" : "Abilita nuovo piè di pagina",
      "stickToSurvey" : " Fissa al sondaggio",
      "backgroundFill" : "Riempimento sfondo",
      "footerHeight" : "Altezza del piè di pagina",
      "enableProgressBar" : "Abilita barra di avanzamento",
      "buttons" : "Pulsanti",
      "button" : "Pulsante",
      "buttonType" : "Tipo di pulsante",
      "fillNext" : "Riempi (successivo)",
      "fillPrevious" : "Riempi (precedente)",
      "fillSubmit" : "Compila (Invia)",
      "textColor" : "Testo del pulsante",
      "position" : "Posizione",
      "previousText" : "Precedente (testo)",
      "nextText" : "Successivo (testo)",
      "submitText" : "Invia (testo)",
      "fillComplete" : "Riempimento completo",
      "fillInactive" : "Riempimento inattivo",
      "footerType" : "Tipo di piè di pagina",
      "stickToCard" : "Fissa alla scheda",
      "stickToPage" : "Fissa alla pagina",
      "stepTextColor" : "Passaggio Corpo Color",
      "progressBarFill" : "Riempi la Barra di avanzamento",
      "progressBarInactive" : "Barra di avanzamento Inattivo",
      "arrowFill" : "Riempi a Freccia",
      "submitColorMobile" : "Invia (Colore)",
      "arrowFillColor" : "Colore Riempi Freccia",
      "buttonTypes" : {
        "textAndArrow" : "Testo e freccia",
        "onlyText" : "Solo Testo",
        "onlyArrow" : "Solo freccia"
      },
      "positions" : {
        "leftAndRight" : "Sinistra e destra"
      },
      "placeholders" : {
        "prev" : "Precedente",
        "next" : "Successivo",
        "submit" : "Invia"
      }
    },
    "surveyNotfication" : "Notifica del sondaggio",
    "style" : {
      "surveyPadding" : "Spaziatura del sondaggio"
    },
    "integratePopup" : {
      "shareOrEmbed" : "Incorpora o Condividi Sondaggio",
      "share" : {
        "openFormLink" : "Apri il Link Sondaggio"
      },
      "email" : {
        "emailSubheader" : "Crea Email vuota e incorpora il tuo Sondaggio, o Seleziona a Modello e incorporalo immediatamente."
      }
    },
    "autoResponderSubheader" : "Invia un'email automatica alla persona che invia il sondaggio (l'email include una copia delle informazioni inserite nel sondaggio)",
    "sendSubmissionsAsPdf" : "Invia l'invio del sondaggio come PDF",
    "switchToOneQuestionAtTimeOn" : "L'attivazione di \"Una domanda per dati\" interrompe la logica condizionale attuale",
    "switchToOneQuestionAtTimeOff" : "La disabilità \"Una domanda a un dato\" influisce sulla tua logica condizionale",
    "switchToOneQuestionAtTimeOnWarning" : "Alcune condizioni non funzioneranno più come previsto. Le domande Quando sono Presentazione one at a Data.",
    "switchToOneQuestionAtTimeOffWarning" : " Alcune condizioni progettate per Flusso della domanda individuale smetteranno di funzionare come previsto.",
    "createContactOnPartialSubmissionSubText" : "Crea un contatto quando un utente fa clic su \"Avanti\" su qualsiasi diapositiva, anche se non completa il sondaggio.",
    "dragDrop" : {
      "imageLabel" : "Immagine {n}",
      "htmlLabel" : "HTML {n}",
      "defaultFolderName" : "Sondaggio {'|'} {name}",
      "defaultTermsHtml" : "<p style=\"text-align: center\"><a target=\"_blank\" rel=\"noopener noreferrer nofollow\" href=\"https://www.example.com\">Informativa sulla Privacy</a> | <a target=\"_blank\" rel=\"noopener noreferrer nofollow\" href=\"https://www.example.com\">Termini di Servizio</a></p>",
      "smsConsent" : "Acconsento a ricevere notifiche SMS, avvisi e occasionali comunicazioni di marketing dall'azienda. La frequenza dei messaggi varia. Potrebbero essere applicate tariffe per messaggi e dati. Invia HELP a (XXX) XXX-XXXX per ricevere assistenza. Puoi rispondere STOP per annullare l'iscrizione in qualsiasi momento."
    }
  },
  "form" : {
    "typeOfBuilder" : "Modulo",
    "formStyle" : "Stile del modulo",
    "formElement" : "Elemento del modulo",
    "addFormElement" : "Aggiungi elemento modulo",
    "addConditionalLogic" : "Aggiungi logica condizionale",
    "openConditionalLogic" : "Apri logica condizionale",
    "inlineForm" : "Modulo in linea",
    "formName" : "Nome del modulo",
    "fullScreenMode" : "Modalità a schermo intero",
    "fullScreenModetooltip" : "L'attivazione di questa opzione farà sì che il modulo si espanda su tutta la larghezza del contenitore, estendendosi fino al bordo dell'area di incorporamento e aderendo alla larghezza del modulo.",
    "enableTimezoneForm" : "Attivando questa opzione si acquisiscono le informazioni sul fuso orario della persona che invia il modulo",
    "formSettings" : "Impostazioni del modulo",
    "unsavedAlertMessage" : "Il modulo contiene lavoro non salvato. Vuoi davvero uscire ed eliminare tutto il lavoro non salvato?",
    "thirdPartyScriptAlertMessage" : "Gli script di terze parti all'interno del blocco HTML possono fornire potenti funzionalità, ma comportano anche rischi per la privacy, la sicurezza, le prestazioni e il comportamento della pagina. Pertanto, ti consigliamo di rivedere il contenuto di questo script prima di salvarlo nel modulo.",
    "onFormSubmission" : "All'invio del modulo",
    "integrateForm" : "Integra modulo",
    "embedlayoutType" : "Incorpora Digita Layout",
    "embedlayoutTypeSubMessage" : "Seleziona un layout da incorporare in un funnel o in un sito web esterno",
    "triggerType" : "Tipo di trigger",
    "showOnScrolling" : "Mostra su scorrimento",
    "showAfter" : "Mostra dopo",
    "seconds" : "secondi",
    "alwaysShow" : "Mostra sempre",
    "activationOptions" : "Opzioni di attivazione",
    "activateOn" : "Attiva il",
    "visit" : "visita",
    "alwaysActivated" : "Sempre attivato",
    "deactivationOptions" : "Opzioni di disattivazione",
    "deactivateAfterShowing" : "Disattiva dopo la visualizzazione",
    "times" : "volte",
    "deactiveOnceLeadCollected" : "Disattiva una volta raccolto il lead",
    "neverDeactivate" : "Non disattivare mai",
    "copyEmbedCode" : "Copia codice di incorporamento",
    "copyFormLink" : "Copia link del modulo",
    "openFormLink" : "Apri il link del modulo",
    "inline" : "In linea",
    "inlineDescription" : "Un modulo in linea viene visualizzato insieme al contenuto della pagina come elemento nativo. Non si sovrappone e non può essere chiuso o ridotto a icona.",
    "inlineHoverDescription" : "Un modulo in linea viene visualizzato insieme al contenuto della pagina come elemento nativo. Non si sovrappone e non può essere chiuso o ridotto a icona.",
    "popup" : "Popup",
    "popupDescription" : "Un popup mostra il modulo come una sovrapposizione all'interno di una light-box. Non può essere ridotto a icona, ma può essere chiuso.",
    "popupHoverDescription" : "Un popup mostra il modulo come una sovrapposizione all'interno di una light-box. Non può essere ridotto a icona, ma può essere chiuso.",
    "politeSlideIn" : "Pannello di cortesia",
    "politeSlideInDescription" : "Un pannello di cortesia appare nella parte inferiore dello schermo e scompare una volta chiuso",
    "politeSlideInHoverDescription" : "Appare nella parte inferiore dello schermo e scompare una volta chiuso",
    "stickySidebar" : "Barra laterale fissa",
    "stickySidebarDescription" : "Una barra laterale fissa apparirà a lato dello schermo e può essere ridotta a icona in una scheda che resta fissa al lato della finestra",
    "stickySidebarHoverDescription" : "Appaiono a lato dello schermo e possono essere ridotti a icona in una scheda che resta fissa al lato della finestra",
    "allowMinimize" : "Consenti riduzione a icona",
    "conditonalLogic" : {
      "conditions" : "Condizioni",
      "noExistingCondition" : "Ancora nessuna condizione esistente",
      "freeRoamMessage" : "Puoi girare liberamente senza regole, almeno per ora",
      "addNewCondition" : "Aggiungi nuova condizione",
      "redirectToUrl" : "Reindirizza all'URL",
      "displayCustomMessage" : "Visualizza messaggio personalizzato",
      "disqualifyLead" : "Squalifica il lead",
      "showHideFields" : "Mostra/Nascondi campi",
      "jumpTo" : "Salta a",
      "redirectToUrlSubText" : "Reindirizza l'utente dopo l'invio",
      "displayCustomMessageSubText" : "Mostra messaggi basati sugli input di Attivo Utente",
      "disqualifyLeadSubText" : "Filtra le voci in condizioni specifiche",
      "showHideFieldsSubText" : "Modifica campo Visibilità in modo dinamico",
      "openBelowUrl" : "Apri l'URL sottostante",
      "showCustomMessage" : "Mostra messaggio personalizzato",
      "alertConditionDelete" : "Vuoi davvero eliminare questa condizione?",
      "deleteCondition" : "Elimina condizione",
      "conditionExecutedMessage" : "Le condizioni verranno eseguite dall'alto verso il basso.",
      "allOperationOptions" : {
        "isEqualTo" : "È uguale a",
        "isNotEqualTo" : "Non è uguale a",
        "contains" : "Contiene",
        "doesNotContain" : "Non contiene",
        "startsWith" : "Inizia con",
        "endsWith" : "Termina con",
        "isEmpty" : "È vuoto",
        "isFilled" : "È riempito",
        "before" : "Prima",
        "after" : "Dopo",
        "greaterThan" : "Maggiore di",
        "lessThan" : "Meno di",
        "between" : "Tra",
        "isChecked" : "È selezionato",
        "isNotChecked" : "Non è selezionato"
      },
      "logic" : {
        "if" : "Se",
        "then" : "Allora",
        "and" : "E",
        "or" : "O"
      },
      "phoneAlertMessage" : "Per cercare numeri di telefono con un prefisso internazionale, devi includere esplicitamente il simbolo \"+\" nella query di ricerca.",
      "deleteAlertMessage" : "Vuoi davvero eliminare questo campo? Verrà rimossa anche la condizione associata a questo campo.",
      "deleteField" : "Elimina campo",
      "jumpToDescription" : "Salta a una diapositiva specifica quando le condizioni sono soddisfatte",
      "cycleError" : "Impossibile Salva. Ciclo rilevato tra {a} e {b}",
      "jumpToSlide" : "Salta alla diapositiva",
      "submitSurvey" : "Salva sondaggio",
      "pageTitle" : "P{index} - {title}",
      "selectSlideToJumpTo" : "Fai clic su Scorri da cui saltare",
      "selectedSlide" : "Diapositiva selezionata",
      "typeValueHere" : "Per favore, digiti un valore qui",
      "field" : "Campo",
      "slide" : "Scorri",
      "selectFieldOrSlide" : "Seleziona campo o diapositiva",
      "selectFieldState" : "Seleziona Stato campo",
      "selectField" : "Seleziona campo",
      "selectOption" : "Seleziona opzione",
      "jumpToTarget" : "Salta a",
      "jumpToQuestion" : "Vai alla Domanda",
      "chooseQuestion" : "Scegli domanda",
      "includeStart" : "Includi inizio",
      "includeEnd" : "Includi la fine",
      "includeValue" : "Includi {value}",
      "hideField" : "Nascondi campo",
      "hideFields" : "Nascondi campi",
      "showField" : "Mostra campo",
      "showFields" : "Mostra campi",
      "additionalRulesPrefix" : "... e",
      "additionalRulesSuffix" : "altre {ifLabel} regole ...",
      "shownTargetsWithMore" : "{shown}, + altri {count}",
      "noConditionsAlt" : "Ancora nessuna condizione",
      "outcomeLabels" : {
        "show" : "Mostra",
        "jumpTo" : "Salta a"
      }
    },
    "minimizedTitlePlaceholder" : "Titolo ridotto",
    "dragYourElementFromLeft" : "Trascina i tuoi elementi qui da sinistra",
    "formNotification" : "Notifica modulo",
    "sendSubmissionsAsPdf" : "Invia l'invio del modulo come PDF",
    "style" : {
      "formPadding" : "Spaziatura modulo"
    },
    "integratePopup" : {
      "shareOrEmbed" : "Incorpora o condividi il modulo",
      "share" : {
        "openFormLink" : "Apri il Link Modulo"
      },
      "email" : {
        "emailSubheader" : "Crea Email vuota e incorpora il tuo modulo, o seleziona un modello e incorporalo immediatamente."
      }
    },
    "choosePosition" : "Seleziona Stato",
    "testBuild" : "Test di build"
  },
  "quiz" : {
    "quizElement" : "Elemento del quiz",
    "quizNotification" : "Notifica quiz",
    "viewAndCustomise" : "Visualizza e personalizza",
    "categoryAndScore" : "Categoria e punteggio",
    "provideFeedback" : "Fornisci un feedback",
    "addQuizElement" : "Aggiungi elemento quiz",
    "typeOfBuilder" : "Quiz",
    "addQuestions" : "Aggiungi domande",
    "dragAndDropQuestion" : "Trascina un elemento Domanda qui.",
    "addNewPage" : "Aggiungi Nuovo Pagina",
    "editTemplate" : "Modifica Modello",
    "editResultPage" : "Modifica pagina dei risultati",
    "clonePage" : "Clona Pagina",
    "category" : {
      "category" : "Categoria",
      "watchVideo" : "Visualizza questo Video per saperne di più Su come la categoria influisce sui risultati Pagina!",
      "useCategoryWhen" : "Usa categorie quando",
      "manageCategories" : "Gestisci Categorie",
      "howItWorks" : "Come funziona 🤔",
      "howItWorks2" : "Come funziona",
      "addCategoryMessage" : "Aggiungi una nuova categoria",
      "assignCategoryMessage" : "Assegna una categoria a ogni opzione",
      "editResultsMessage" : "Punteggio Mostra Categoria in Risultato Pagina",
      "addCategory" : "Aggiungi Categoria",
      "deleteCategoryAlertMessage" : "Eliminazione una categoria risulterà nella riposo di quella categoria in ogni Opzioni",
      "editOrAddNewCategories" : "Puoi modificare o includere nuove categorie",
      "toEvaluateTheResponder" : "Per confrontare il risponditore Attivo ha basato diversi fattori",
      "showMultipleCategoryScore" : "Mostra il punteggio di Mostra multipla categoria in Risultato Pagina",
      "displayVaryingContent" : "Visualizzazione variabile Contenuti Attivo i risultati Pagina dipende dalla categoria di punteggio di Attivo",
      "theOptionFieldIsRequired" : "Il campo dell'opzione è obbligatorio",
      "addManage" : "Aggiungi / Gestisci",
      "enterCategoryPlaceholder" : "Inserisci il nome della categoria",
      "carouselAlt" : "Diapositiva di anteprima della categoria"
    },
    "quizSettings" : "Impostazioni del quiz",
    "onQuizSubmission" : "All'invio del quiz",
    "settings" : "Impostazioni",
    "deletePage" : "Elimina pagina",
    "quizResult" : {
      "resultTemplate" : "Modello di risultato",
      "quizResultAlertMessage" : "La pagina dei risultati scelta verrà mostrata una volta completato il quiz",
      "overallScoreLabel" : "Punteggio complessivo"
    },
    "autoResponderSubheader" : "Invia un'e-mail automatica alla persona che invia il quiz (l'e-mail include una copia delle informazioni inserite nel quiz)",
    "sendSubmissionsAsPdf" : "Invia l'invio del quiz come PDF",
    "sendQuizResultsAsPdf" : "Invia il risultato del quiz come PDF",
    "integrateHeader" : "Integra quiz",
    "integrateSubHeader" : "Usa le seguenti opzioni per integrare il tuo quiz personalizzato nel tuo sito web",
    "integrateCopyLinkMessage" : "Copia il link qui sotto e condividilo facilmente ovunque desideri.",
    "pageLabel" : "Pagina {n}",
    "pageName" : "Nome della pagina",
    "pagePosition" : "Posizione della pagina",
    "createContactOnPartialSubmissionSubText" : "Crea un contatto quando un utente fa clic su \"Avanti\" su qualsiasi diapositiva, anche se non completa il quiz.",
    "integratePopup" : {
      "shareOrEmbed" : "Incorpora o Condividi Quiz",
      "share" : {
        "openFormLink" : "Apri il Link del quiz"
      },
      "email" : {
        "emailSubheader" : "Crea Email vuota e incorpora il tuo quiz, o seleziona un modello e incorporalo immediatamente."
      }
    }
  },
  "textEditor" : {
    "textAlign" : "Allineamento del testo",
    "list" : "Elenco",
    "sourceCode" : "Codice sorgente",
    "resetStyle" : "Ripristina stile",
    "resetDocumentStyle" : "Reimpostare lo stile del documento"
  }
}
